export default "__VITE_ASSET__DLbujgeD__"